import React, {useEffect, useMemo, useRef, useState} from 'react'
import { useForm } from 'react-hook-form'
import HookForm from '../../components/common/HookForm'
import styles from './EventPageBuilder.module.css'
import {useParams} from "react-router";
import {AuthToken, useAuthToken} from "../../slices/authSlice";
import axios from "axios";
import {useAutoEvt} from "../../queries/useAutoEvt";
import {parseJwt} from "../AuthPage/LoginForm/useLoginMutation";
import Bee from "@beefree.io/sdk";
import {getConfig} from "../../AppConfig";
import cn from "classnames";
import { Button } from "@material-ui/core";
import { Fullscreen, FullscreenExit } from "@material-ui/icons";
const { beeFreeTokenUrl } = getConfig()

interface Params {
  id: string
}

const EventPageBuilder = ({ isEdit = false }) => {
    const { id } = useParams<Params>()
    useAutoEvt(id)
    const formMethods = useForm<FormData>()
    const authToken = useAuthToken()

    const [landingPage, setLandingPage] = React.useState<string>("");
    const [landingPageHTML, setLandingPageHTML] = React.useState<string>("");
    const [isFullscreen, setIsFullscreen] = React.useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        document.body.style.overflow = isFullscreen ? 'hidden' : ''
        return () => {
            document.body.style.overflow = ''
        }
    }, [isFullscreen])
    const setTemplates = async (eventId, templateString, templageHTML) => {
        const htmlString = JSON.stringify(templageHTML)
        const body = {eventid: eventId, landing: JSON.stringify(templateString), landinghtml: htmlString}
        const {data} = await axios.put('/evtsettingslanding', body)
    }

    useEffect(() => {
        if (landingPage.length > 0) {
            setTemplates(id, landingPage, landingPageHTML)
        }
    }, [landingPage])

    useEffect(() => {
        const getTemplates = async (eventId) => {
            const json = JSON.stringify({ eventid: eventId })
            const { data } = await axios.post('/evtsettingslanding', json, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            const parsedData = JSON.parse(data.jsonString)

            const token = localStorage.getItem('tokenadmin')
            const parsedToken: AuthToken = parseJwt(token)
            const configuration = {
                // uid: parsedToken?.sitecode,  // Change this to fit your project
                container: 'bee-plugin-container',
                language: 'en-US',
                onSave: (pageJson: string, pageHtml: string, ampHtml: string | null, templateVersion: number, language: string | null) => {
                    console.log('Saved!', { pageJson, pageHtml, ampHtml, templateVersion, language });
                    setLandingPageHTML(pageHtml)
                    setLandingPage(pageJson)
                },
                onError: (error: unknown) => {
                    debugger;
                    console.error('Error:', error);
                }
            }

            const url = beeFreeTokenUrl + '?uid=' + parsedToken?.sitecode + '&code=2UZhG7Z1YktiwPVPgm1m3VDPb1Il9Pp4CX7XWl74gmXUAzFusaaUnQ=='
            axios.get(url).then(response => {
                const sdk = new Bee(response.data)
                sdk.start(configuration, parsedData?.landing?.length > 50 ? JSON.parse(parsedData?.landing) : {})
            })

            // const tokenObj = await sdk.UNSAFE_getToken(clientId, clientSecret)
            if (parsedData?.landinghtml?.length > 0) {
                setLandingPageHTML(JSON.parse(parsedData?.landinghtml))
            }
            if (parsedData?.landing?.length > 0) {
                setLandingPage(JSON.parse(parsedData?.landing))
            }
        }

        getTemplates(id)

    }, [])

    return (
        <div className={styles.root}>
            <h1>Event Page Builder</h1>
            <HookForm
                methods={formMethods}
                onSubmit={() => {}}
                className={styles.form}
                formProps={{ id: 'EventPageBuilder-form-new' }}>
                {/*<LoadingBackdrop open={isFetching} />*/}

                <div className={cn(styles.editorWrapper, isFullscreen && styles.editorWrapperFullscreen)}>
                    <div className={styles.fullscreenBanner}>
                        <div className={styles.fullscreenBannerLeft}>
                            <span className={styles.fullscreenBannerIcon}>
                                {isFullscreen ? <FullscreenExit fontSize="small" /> : <Fullscreen fontSize="small" />}
                            </span>
                            <span>
                                {isFullscreen
                                    ? <><strong>You're in full screen mode.</strong> Exit to return to the regular page layout.</>
                                    : <><strong>This editor works best in full screen.</strong> You'll get the whole window to design and preview your page.</>}
                            </span>
                        </div>
                        <Button
                            className={styles.fullscreenBannerButton}
                            variant="contained"
                            disableElevation
                            startIcon={isFullscreen ? <FullscreenExit /> : <Fullscreen />}
                            onClick={() => setIsFullscreen((current) => !current)}>
                            {isFullscreen ? 'Exit full screen editor' : 'Open full screen editor'}
                        </Button>
                    </div>
                    <div
                        ref={containerRef}
                        style={isFullscreen ? {flex: '1 1 auto', minHeight: 0} : {height: '600px'}}
                        id="bee-plugin-container">
                    </div>
                </div>

                {/*<FloatingButton*/}
                {/*    type="submit"*/}
                {/*    variant="contained"*/}
                {/*    className={styles.button}*/}
                {/*    form="EventSettings-form-new"*/}
                {/*>*/}
                {/*    Save*/}
                {/*</FloatingButton>*/}
            </HookForm>
        </div>
    )
}

export default EventPageBuilder
